/**
 * @generated SignedSource<<5356dd5e2ba160c0310523b442010161>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignSeriesCollectionItem_design$data = {
  readonly displayName: string | null;
  readonly imageUrl: string | null;
  readonly linkData: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  };
  readonly " $fragmentType": "DesignSeriesCollectionItem_design";
};
export type DesignSeriesCollectionItem_design$key = {
  readonly " $data"?: DesignSeriesCollectionItem_design$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesCollectionItem_design">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignSeriesCollectionItem_design",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    }
  ],
  "type": "IconicDesignSeriesItem",
  "abstractKey": null
};

(node as any).hash = "9bb5810363ee7be9622b1ad6cd0bfb38";

export default node;
